export default "__VITE_ASSET__CZC09Bu5__"